import React, { ChangeEvent } from 'react';
import { Checkbox, makeStyles } from 'e100-react-components';
import classNames from 'classnames';
import { useSubscriptionConsentContext } from '../../../../context/subscriptionConsent';
import { useIntl } from 'react-intl';
import Box from 'components/Box';
import { InfoButton } from 'shared/components';
import {
  ConsentDataProcessingLocatorPROServicesTooltip,
  ConsentToMarketingCommunicationsTooltip,
} from './totltipTemplates';

const useStyles = () =>
  makeStyles(({ typography }) => ({
    checkboxLabelRoot: {
      marginRight: 0,
      '& span': {
        marginRight: 2,
        paddingRight: 0,
      },
    },
    lastCheckboxLabelRoot: {
      marginRight: 0,
    },
    checkboxLabel: {
      fontSize: typography.body2.fontSize,
    },
  }))();

export const Consent = () => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const { setConsent, consent } = useSubscriptionConsentContext();

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>, isChecked: boolean) => {
    const { name } = event.target;
    setConsent({
      ...consent,
      [name]: isChecked,
    });
  };
  return (
    <Box display="flex" gap={2}>
      <Box display="flex" alignItems="center">
        <Checkbox
          name="marketing"
          isChecked={consent.marketing}
          //@ts-ignore
          onChange={handleCheckboxChange}
          classes={{
            formControlLabel: {
              root: classes.checkboxLabelRoot,
              label: classes.checkboxLabel,
            },
          }}
          label={formatMessage({ id: 'consentToMarketingCommunications' })}
        />
        <InfoButton title={<ConsentToMarketingCommunicationsTooltip />} />
      </Box>

      <Box display="flex" alignItems="center">
        <Checkbox
          name="legal"
          isChecked={consent.legal}
          //@ts-ignore
          onChange={handleCheckboxChange}
          classes={{
            formControlLabel: {
              root: classNames(classes.checkboxLabelRoot, classes.lastCheckboxLabelRoot),
              label: classes.checkboxLabel,
            },
          }}
          label={formatMessage({ id: 'consentToLegalMatters' })}
        />
        <InfoButton title={<ConsentDataProcessingLocatorPROServicesTooltip />} />
      </Box>
    </Box>
  );
};
